module.exports = __webpack_public_path__ + "05f56935643b0fec8254901cdd530cb0.pdf";